import { useI18n } from "@wojo/localization";
import { AssetStoryblok, StoryblokImage } from "@wojo/storyblok";
import { Markdown, Modal, ModalBody, ModalProps, Text } from "@wojo/ui";
import React from "react";
import { LuClock4, LuTicket } from "react-icons/lu";
import styles from "./Itinerary.module.scss";

type ItineraryExcursionModalProps = ModalProps & {
    name?: string;
    image?: AssetStoryblok;
    departureInfo?: string;
    duration?: string;
    description?: string;
    dpdDeadline?: string;
    price?: string | null;
};

export const ItineraryExcursionModal: React.FC<
    ItineraryExcursionModalProps
> = ({
    name,
    image,
    departureInfo,
    duration,
    description,
    dpdDeadline,
    price,
    ...modalProps
}) => {
    const { productPage } = useI18n("productPage");
    return (
        <Modal {...modalProps}>
            <ModalBody style={{ paddingBottom: "var(--g-spacing-md)" }}>
                <Text.Heading
                    order="4"
                    tag="h2"
                    style={{ marginBottom: "var(--g-spacing-sm)" }}
                >
                    {name}
                </Text.Heading>
                {price && (
                    <Text.Body className={styles["excursion-modal-detail"]}>
                        <span
                            className={
                                styles["excursion-modal-detail-icon-wrapper"]
                            }
                        >
                            <LuTicket aria-hidden size={16} />
                        </span>
                        <span>
                            {productPage.itinerary.day.excursion.price.l({
                                price,
                            })}
                        </span>
                    </Text.Body>
                )}
                {(!!duration || !!departureInfo) && (
                    <Text.Body className={styles["excursion-modal-detail"]}>
                        <span
                            className={
                                styles["excursion-modal-detail-icon-wrapper"]
                            }
                        >
                            <LuClock4 aria-hidden size={16} />
                        </span>
                        <span>
                            {`${duration}${
                                !!duration && !!departureInfo && ", "
                            }${departureInfo}`}
                        </span>
                    </Text.Body>
                )}
                {/* TODO: Uncomment when we can get the deadline from the graph https://ef-wojo.atlassian.net/browse/WWR-563
                {!!dpdDeadline && (
                    <AlertBasic
                        status="info"
                        title={productPage.itinerary.day.excursion.dpdAlertMessage.l(
                            { dpdDeadline },
                        )}
                        style={{
                            borderTop:
                                "var(--g-border-width-xs) solid var(--s-color-separator-standard)",
                            paddingTop: "var(--g-spacing-md)",
                            marginTop: "var(--g-spacing-md)",
                        }}
                    />
                )}
                */}
            </ModalBody>
            {!!image?.filename && (
                <StoryblokImage
                    className={styles["excursion-modal-image"]}
                    mobile={{ asset: image, size: { width: 1534 } }}
                    desktop={{ asset: image, size: { width: 996 } }}
                />
            )}
            {!!description && (
                <ModalBody>
                    <Markdown markdown={description} />
                </ModalBody>
            )}
        </Modal>
    );
};
